<template>
  <div id="logins" v-loading="loading">
    <div class="login_main w_relative" :style="{backgroundImage:'url('+loginbg+')'}">
      <div class="logo_text">
        <!-- <img src="../../assets/images/login_logo.png" alt="" /> -->
        <!-- <span>{{name}}</span> -->
      </div>
      <div class="login_form_box">
        <el-row class="row-bg" type="flex" justify="space-around">
          <el-col :span="10">
            <!-- <img
              style="width: 100%;position:relative;top:-15%; max-width: 550px; max-width: 450px;"
              src="../../assets/images/login_text.png"
              alt=""
            /> -->
          </el-col>
          <el-col :span="8">
            <div class="el-form-box">
              <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-width="60px"
                :hide-required-asterisk="true">
                <div class="login_form_title">登录</div>
                <el-form-item label="用户名:" prop="username">
                  <el-input ref="username" placeholder="请输入账号" v-model="loginForm.username"></el-input>
                </el-form-item>
                <el-form-item label="密码:" prop="password">
                  <el-input type="password" ref="password" class="inputBox" placeholder="请输入密码"
                    v-model="loginForm.password"></el-input>
                </el-form-item>
                <el-form-item label="验证码:" prop="imgcode" class="imgcodeBOx">
                  <div class="imgcode_box">
                    <el-input class="inputBox" placeholder="请输入验证码" v-model="loginForm.imgcode"
                      popper-class="my-autocomplete"></el-input>
                    <img :src="imgcode" @click="getImgCode" />
                  </div>
                </el-form-item>
                <div class="login_password">
                  <span @click="clearSession">忘记密码？</span>
                </div>
                <el-row class="el-row-top">
                  <el-col :span="24">
                    <el-button :loading="loading" type="danger" class="loginbtn" @click.native.prevent="handleLogin">登录
                    </el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="position:absolute;bottom:0;left:0;text-align:center;width:100%">
        <a href="http://beian.miit.gov.cn/" target="_blank" style="color:#fff;">蜀ICP备18036713号-6 </a>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import BranchRouter from "./BranchRouter.json"
  import CommitteeRouter from "./CommitteeRouter.json"
  import OrganizationDepartmentRouter from "./OrganizationDepartmentRouter.json"
  import MessageBox from "@/components/MessageBox";
  import { baseURL } from "@/assets/js/baseURL"
  import {
    $ws
  } from "@/assets/js/websocket/newsocket"
  import Vcode from "vue-puzzle-vcode";
  export default {
    components: {
      Vcode
    },
    data() {
      const validateUsername = (rule, value, callback) => {
        if (!value) {
          callback(new Error("请输入正确的用户名"));
        } else {
          callback();
        }
      };
      const validatePassword = (rule, value, callback) => {
        if (value.length < 6) {
          callback(new Error("密码不能少于6位数字"))
        } else {
          callback()
        }
        const validateImage = (rule, value, callback) => {
          if (!value) {
            callback(new Error("请输入正确的验证码"));
          } else {
            callback();
          }
        };
      };
      return {
        loginbg: "",
        loading: true,
        name: "",
        loginForm: {
          username: "",
          password: "",
          imgcode: ""
        },
        loginRules: {
          username: [
            { required: true, trigger: "blur", validator: validateUsername },
          ],
          password: [
            { required: true, trigger: "blur", validator: validatePassword },
          ],
          imgcode: [
            // { required: true, trigger: "blur", validator: validateImage },
          ],
        },
        loading: false,
        imgcode: "",
      };
    },
    created() {
      this.captch()
      // 回车登录
      document.onkeydown = function (e) {
        const that = this
        var theEvent = window.event || e;
        var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
        if (code == 13) {
          $(".loginbtn").click()
        }
      }
      sessionStorage.clear()
      let href = window.location.href
      if (href === "http://webs.chinahc.wang/#/") {
        //党委
        this.loginbg = require('@/assets/images/dw_loginbg.jpg')
        this.name = "党委工作信息化手册"
      } else {
        //支部
        this.loginbg = require('@/assets/images/dzb_loginbg.jpg')
        this.name = "党支部工作信息化手册"
      }
      this.checkLogin()
    },
    methods: {
      // 获取验证码图片
      getImgCode() {
        this.captch();
      },
      captch() {
        let url = baseURL
        this.imgcode = url + '/admin/captcha_pro?' + Date.parse(new Date());
      },
      clearSession() {
        sessionStorage.clear()
        this.RouteGo('ForgotPassword')
      },
      // 检测当前是否是登录状态，如果是登录状态，则直接跳转至home页面
      async checkLogin() {
        const that = this
        const date = new Date()
        const nowTime = date.getTime() / 1000
        // 如果曾经登录过且token未过期,就直接跳转到Home页面
        let token = localStorage.Token
        let expires_time = localStorage.expires_time
        if (token !== undefined && expires_time > nowTime) {
          const data = await this.PublicApi("admin/organization/getId")
          // 管理人员身份认证获取
          this.$setSession("ISCOM", data.data.is_com)
             // 设置组织等级
        this.$setSession("OCATEGRORYID", data.data.o_category_id)
          //设置是否是领头羊
          this.$setSession("is_top_public", data.data.is_top_public)
          const ISCOM = parseInt(this.$getSession("ISCOM"))
          if (ISCOM === 1) {
            // 1是党委 0是支部
            // 增加o_category_id =4 判断党组织
            if(data.data.o_category_id == 4){
              that.$store.state.HCRoutes = OrganizationDepartmentRouter
            } else {
              that.$store.state.HCRoutes = CommitteeRouter
            }
          } else {
              that.$store.state.HCRoutes = BranchRouter
          };

          that.loading = false
          this.$message({
            message: '系统检测到您已登录，自动为您跳转到系统首页',
            type: 'success'
          });
          that.RouteGo('Home')
        } else {
          that.RouteGo('Login')
        }
      },
      /**
       * 登录账号
       */
      handleLogin() {
        const that = this
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            // 异步形式登录
            this.$store
              .dispatch("user/login", this.loginForm)
              .then(async (items) => {
                Vue.use($ws)
                $ws.newsocket()
                // 判断是否是顶级党委
                this.$setSession("TOPLEVEL", items.top_level)
                // 判断手机号是否注册
                if (items.is_complete) {
                  const data = await this.PublicApi("admin/organization/getId")
                  // 管理人员身份认证获取
                  this.$setSession("ISCOM", data.data.is_com)
                     // 设置组织等级
        this.$setSession("OCATEGRORYID", data.data.o_category_id)
          //设置是否是领头羊
          this.$setSession("is_top_public", data.data.is_top_public)

                  const ISCOM = parseInt(this.$getSession("ISCOM"))
                  if (ISCOM === 1) {
                    // 1是党委 0是支部
                    // 增加o_category_id =4 判断党组织
                    if(data.data.o_category_id == 4){
                      that.$store.state.HCRoutes = OrganizationDepartmentRouter
                    } else {
                      that.$store.state.HCRoutes = CommitteeRouter
                    }
                  } else {
                    that.$store.state.HCRoutes = BranchRouter
                  }
                  let userinfodata = await this.PublicApi("admin/base/getUserInfo")
                  //topid==0   //visit_screen ==1
                  // if (userinfodata.data.top_id == 0) {
                  //   that.$router.push({ name: "Menus" });
                  // }

                  if (userinfodata.data.visit_screen == 1) {
                    that.$router.push({ name: "Menus" });
                  }
                  else {
                    that.$router.push({ name: "Home" });
                  }
                  this.loading = false
                } else {
                  this.$confirm('此账号未绑定手机号！', '提示', {
                    confirmButtonText: '前往绑定',
                    cancelButtonText: '暂不绑定',
                    type: 'warning'
                  }).then(() => {
                    // console.log("点击注册了");
                    this.RouteGo('registration')
                  }).catch(async () => {
                    const data = await this.PublicApi("admin/organization/getId")
                    // 管理人员身份认证获取
                    this.$setSession("ISCOM", data.data.is_com)
                       // 设置组织等级
                   this.$setSession("OCATEGRORYID", data.data.o_category_id)
                   //设置是否是领头羊
                   this.$setSession("is_top_public", data.data.is_top_public)
                    const ISCOM = parseInt(this.$getSession("ISCOM"))
                    if (ISCOM === 1) {
                      // 1是党委 0是支部
                      // 增加o_category_id =4 判断党组织
                      if(data.data.o_category_id == 4){
                        that.$store.state.HCRoutes = OrganizationDepartmentRouter
                      } else {
                        that.$store.state.HCRoutes = CommitteeRouter
                      }
                    } else {
                      that.$store.state.HCRoutes = BranchRouter
                    }
                    let userinfodata = await this.PublicApi("admin/base/getUserInfo")
                    //topid==0   //visit_screen ==1
                    // if (userinfodata.data.top_id == 0) {
                    //   that.$router.push({ name: "Menus" });
                    // }
                    // else
                    if (userinfodata.data.visit_screen == 1) {
                      that.$router.push({ name: "Menus" });
                    }
                    else {
                      that.$router.push({ name: "Home" });
                    }
                    this.loading = false
                  });
                }
              })
              .catch((data) => {
                this.$message.error(data.msg)
                this.loading = false
              });
          } else {
            console.log("登录失败")
            return false
          }
        });
      },
    },
  };
</script>
<style lang="less">
  @import url("../../assets/css/common.less");

  .login_main {
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/login_bc.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;
  }

  #logins {
    height: 100%;
  }

  .logo_text {
    position: absolute;
    top: 4%;
    left: 1.5%;
    width: 70%;

    img {
      width: 80px;
      vertical-align: middle;
      margin-right: 1%;
    }

    span {
      color: #bf0101;
      font-size: 30px;
      font-weight: 500;
      font-weight: 800;
      letter-spacing: 2px;
    }
  }

  .login_form_box {
    width: 85%;
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .el-form-box {
    background-color: #fff;
    padding: 22px 26px;
    min-width: 300px;
    max-width: 400px;
    box-sizing: border-box;
  }

  .imgcode_box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    >img {
      width: 45%;
      height: 100%;
    }

    .inputBox {
      width: 45%;
      height: 100%;
      border: 0;
      padding: 0;
    }
  }

  .login_form_title {
    color: #ee2727;
    padding: 0px 0 7px 0px;
    border-bottom: 1px solid #f2f2f2;
    font-size: 21px;
    font-weight: 600;
  }

  // 表单按钮修改样式
  #logins {
    .el-form-item__label {
      padding: 0 14px 0 0;
    }

    .el-button--danger {
      background-color: #ee2727;
      border-color: #ee2727;
    }

    .el-button {
      font-size: 16px;
      letter-spacing: 2px;
    }

    .el-form-item {
      margin-top: 40px;
    }
  }

  .loginbtn {
    width: 100%;
    margin-top: 1%;
  }

  /*
    登录忘记密码
  */
  .login_password {
    color: #ee2727;
    padding: 0px 0 7px 10px;
    border-bottom: 1px solid #f2f2f2;
    font-size: 12px;
    font-weight: 600;
    text-align: right;

    /*步骤条样式修改*/
    .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__head.is-finish {
      color: #eb6f67 !important;
      border-color: #eb6f67 !important;
    }

    .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__title.is-finish {
      color: #666666;
    }

    .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/.el-step__description.is-finish {
      color: #999999;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Login/index.vue